import {match} from 'ts-pattern';
import {z} from 'zod';

import i18n from '@dms/i18n';

export type FormValues = z.infer<ReturnType<typeof getSchema>>;

const schema = z.object({
  firstName: z.string().min(1, {message: i18n.t('general.errors.mixed.required')}),
  lastName: z.string().min(1, {message: i18n.t('general.errors.mixed.required')}),
  branchIds: z.array(z.string()).min(1, {message: i18n.t('general.errors.mixed.required')}),
  defaultBranchId: z.string().min(1, {message: i18n.t('general.errors.mixed.required')}),
  roles: z.array(z.string()).min(1, {message: i18n.t('general.errors.mixed.required')}),
  insurerNumber: z.string().nullable().optional(),
  customId: z.string().nullable().optional(),
});

const updateUserSchema = schema.extend({
  email: z.string().nullable().optional(),
  password: z.string().nullable().optional(),
  confirmPassword: z.string().nullable().optional(),
});

const inviteUserSchema = schema.extend({
  email: z.string().email(),
  password: z.string().nullable().optional(),
  confirmPassword: z.string().nullable().optional(),
});

const createUserSchema = schema
  .extend({
    email: z.string().min(1, {message: i18n.t('general.errors.mixed.required')}),
    password: z
      .string()
      .min(1, {message: i18n.t('general.errors.mixed.required')})
      .min(8, {message: i18n.t('errors.too_small.string.inclusive', {minimum: 8})})
      .refine((password) => /\d/.test(password), {
        message: i18n.t('general.errors.mixed.atLeastOneNumber'),
      }),
    confirmPassword: z.string().min(1, {message: i18n.t('general.errors.mixed.required')}),
  })
  .superRefine((data, ctx) => {
    if (data.password && data.confirmPassword && data.password !== data.confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.notifications.errorPasswordsNotMatch'),
        path: ['confirmPassword'],
      });
    }
  });

type schemaType = 'create' | 'update' | 'invite';
export const getSchema = (type: schemaType) =>
  match(type)
    .with('create', () => createUserSchema)
    .with('update', () => updateUserSchema)
    .with('invite', () => inviteUserSchema)
    .exhaustive();
